export default class Downloads {
  /**
   * Creates a tracking instance that handles all downloads
   *
   */
  constructor() {
    this.materialConfig = {
      selectors: {
        material: ".Tracking--material",
        downloadBtn: ".Tracking--materialDownloadBtn",
      },
      attributes: {
        type: "data-type",
        headline: "data-headline",
      },
      mapping: {
        education: "Bildungsmaterial",
        info: "Infomaterial",
        testament: "Testament",
        publication: "Publikation",
      },
    };

    this._init();
  }

  /**
   * binds user events
   *
   * @private
   */
  _init() {
    const materials = [
      ...document.querySelectorAll(this.materialConfig.selectors.material),
    ];

    materials.forEach((material) => {
      const downloadBtn = material.querySelector(
        this.materialConfig.selectors.downloadBtn
      );

      if (downloadBtn) {
        downloadBtn.addEventListener("click", () => {
          this._onClickOnMaterialDownload(material);
        });
      }
    });
  }

  /**
   * handles click on material download
   *
   * @param {HTMLElement} material
   * @private
   */
  _onClickOnMaterialDownload(material) {
    const type = material.getAttribute(this.materialConfig.attributes.type);
    const headline = material.getAttribute(
      this.materialConfig.attributes.headline
    );
    const mappedType = this.materialConfig.mapping[type];

    const materialLink = material.querySelector("a");
    const materialLinkHref = materialLink.getAttribute("href");
    const fileExtension = materialLinkHref.split(".").pop();

    window.dataLayer.push({
      event: "Event",
      event_name: "document_download",
      document_download: {
        document_name: headline,
        document_type: mappedType,
        pp_event_category: "document download",
        pp_event_action: mappedType,
        pp_event_name: headline,
        file_extension: fileExtension,
      },
    });
  }
}
